import cx from "classnames";
import Link from "next/link";
import React, { ElementType } from "react";

import { Media } from "@/components/elements/Media";
import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

export type ArticlePreviewProps = {
  version?: "full" | "preview";
  title: string;
  imgSrc: string;
  link: string;
  as?: ElementType;
  className?: string;
  subTitle?: string;
};

export const ArticlePreview = ({
  version = "full",
  title,
  imgSrc,
  link,
  as: Element = "div",
  className,
  subTitle = "",
}: ArticlePreviewProps) => {
  const isFullVersion = version === "full";

  return (
    <Element
      className={cx(
        styles.container,
        {
          [styles._previewVersion]: version === "preview",
          [styles._fullVersion]: isFullVersion,
        },
        className
      )}
    >
      <div className={styles.figureWrapper}>
        <Link href={link}>
          <Media
            className={styles.figure}
            src={imgSrc}
            alt={title}
            aspectRatio={version === "preview" ? "square" : "landscape"}
            objectFit="cover"
            priority
            sizes={
              version === "preview"
                ? "(max-width: 992px) 6rem, 33vw"
                : "(max-width: 800px) 100vw, (max-width: 992px) 50vw, 33vw"
            }
          />
        </Link>
      </div>
      <div className={styles.infoContainer}>
        <div className={className}>
          <div className={styles.titlePrice}>
            <Text as="div" size={"m"}>
              {title}
            </Text>
          </div>
          <div className={styles.brandSize}>
            <Text as="div" size={"xs"}>
              {subTitle}
            </Text>
          </div>
        </div>
      </div>
    </Element>
  );
};

export default ArticlePreview;
